import { useQuery } from '@tanstack/react-query'
import api from '../../api'

const usePlatformOptions = (enabled = true) =>
	useQuery({
		queryKey: ['tagDetails', 'platforms'],
		queryFn: () => api.tags.getTagDetails('platforms'),
		enabled,
		select: (data) => data.tagDetailValue
	})

export default usePlatformOptions